import { render, staticRenderFns } from "./NavTab.vue?vue&type=template&id=4f419949&scoped=true&"
import script from "./NavTab.vue?vue&type=script&lang=js&"
export * from "./NavTab.vue?vue&type=script&lang=js&"
import style0 from "./NavTab.vue?vue&type=style&index=0&id=4f419949&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f419949",
  null
  
)

export default component.exports